<div class="d-flex w-100 h-100">

  <!-- Off-canvas menu for mobile -->
  <ng-template #menuContent>
    <div class="offcanvas-body p-0">
      <coach-sidebar [activeUrl]="activeUrl" (navigated)="closeMenu()"></coach-sidebar>
    </div>
  </ng-template>

  <div class="sidebar-desktop d-none d-lg-block h-100">
    <coach-sidebar [activeUrl]="activeUrl"></coach-sidebar>
  </div>

  <div class="main-wrapper d-flex flex-column w-100 h-100">
    <coach-header [titleKey]="activeTitleKey" (menuToggled)="openMenu()"></coach-header>

    <div class="content-wrapper w-100 h-100 px-3 px-lg-4 pb-4">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>
